
export const optimizationTargetOptions = {
  maximizeFinancialBenefits: "Maximize Financial Benefits",
  maximizeProduct: "Maximize Product",
  minimizeEnergyCost: "Minimize Energy Cost",
};

export const DEFAULT_PRESSURE_DROP_ABS_THRESHOLD_BAR = 1;

export const outlierConfig = {
 n_neighbors: {
    key: "clusterPoints",
    isInteger: true,
    minValue: 5,
    maxValue: 1000000,
    ranges: { hard: { min: 5, max: 1000000 } },
    maxLength: 10,
    leftLabelKey: "clusterPointsLeft",
    rightLabelKey: "clusterPointsRight",
  },
 window:{
    key: "medianCurvePoints",
    minValue: 5,
    maxValue: 1000000,
    ranges: { hard: { min: 5, max: 1000000 } },
    isInteger: true,
    maxLength: 10,
    leftLabelKey: "medianCurvePointsLeft",
    rightLabelKey: "medianCurvePointsRight",
  },
   n: {
    key: "maxRelativeDistance",
    minValue: 1,
    maxValue: 5,
    ranges: { hard: { min: 1, max: 5 } },
    maxLength: 10,
    leftLabelKey: "maxRelativeDistanceLeft",
    rightLabelKey: "maxRelativeDistanceRight",
  },
};

export const cipAndShutdownConfig = (pressure) => {
  const pressureDropAbsRangeByUnit = {
    psig: { min: 10, max: 100, defaultValue: 15 },
    bar: { min: 0.7, max: 6.9, defaultValue: 1.0 },
    kPa: { min: 70, max: 690, defaultValue: 100 },
  };

  const pressureDropAbsRange =
    pressureDropAbsRangeByUnit[pressure] || pressureDropAbsRangeByUnit.bar;

  return {
    pressure_drop_threshold: {
      type: "checkboxGroup",
      defaultSelected: "percentage",
      options: {
        percentage: {
          key: "pressureDropThreshold",
          labelKey: "pressureDropPercentThreshold",
          settingsKey: "pressure_drop_threshold",
          minValue: 5,
          maxValue: 100,
          defaultValue: 10,
          ranges: { hard: { min: 5, max: 100 } },
          maxLength: 10,
          leftLabelKey: "cipSliderLeft",
          rightLabelKey: "cipSliderRight",
        },
        absolute: {
          key: "pressureDropThresholdAbsolute",
          labelKey: "pressureDropAbsThreshold",
          settingsKey: "pressure_drop_abs_threshold",
          minValue: pressureDropAbsRange.min,
          maxValue: pressureDropAbsRange.max,
          defaultValue: pressureDropAbsRange.defaultValue,
          ranges: {
            hard: {
              min: pressureDropAbsRange.min,
              max: pressureDropAbsRange.max,
            },
          },
          maxLength: 10,
          leftLabelKey: "cipSliderLeft",
          rightLabelKey: "cipSliderRight",
        },
      },
    },
  };
};

export const cipAndShutdownStaticConfig = {
    use_salt_passage: {
      key: "useSaltPassageChange",
      type: "radio",
      options: [
        { name: "yes", value: "true", key: "use_salt_passage_yes" },
        { name: "no", value: "false", key: "use_salt_passage_no" },
      ],
    },
    min_day_between_cips: {
      key: "minDaysBetweenCIPs",
      type: "number",
      minValue: 1,
      maxValue: 90,
      ranges: { hard: { min: 1, max: 90 } },
      isInteger: true,
      maxLength: 10,
      leftLabelKey: "cipSliderLeft",
      rightLabelKey: "cipSliderRight",
    },
    max_days_between_cips: {
      key: "maxDaysBetweenCIPs",
      type: "number",
      minValue: 1,
      maxValue: 365,
      ranges: { hard: { min: 1, max: 365 } },
      isInteger: true,
      maxLength: 10,
      leftLabelKey: "cipSliderLeft",
      rightLabelKey: "cipSliderRight",
    },
    k: {
      key: "cipIdentificationResolution",
      type: "number",
      minValue: 1,
      maxValue: 10,
      ranges: { hard: { min: 1, max: 10 } },
      maxLength: 10,
      leftLabelKey: "cipSliderLeft",
      rightLabelKey: "cipSliderRight",
    },
    shutdown_length: {
      key: "minIdleDaysShutdown",
      type: "number",
      minValue: 5,
      maxValue: 50,
      ranges: { hard: { min: 5, max: 50 } },
      isInteger: true,
      maxLength: 10,
      leftLabelKey: "cipSliderLeft",
      rightLabelKey: "cipSliderRight",
    },
    use_permeability_trigger: {
      key: "usePermeabilityTrigger",
      type: "radio",
      authorization: ["internal", "admin"],
      options: [
        { name: "yes", value: "true", key: "use_permeability_trigger_yes" },
        { name: "no", value: "false", key: "use_permeability_trigger_no" },
      ],
    },
    permeability_only: {
      key: "usePermeabilityOnly",
      type: "radio",
      authorization: ["internal", "admin"],
    },
    permeability_threshold: {
      key: "permeabilityThreshold",
      type: "number",
      minValue: 1,
      maxValue: 100,
      ranges: { hard: { min: 1, max: 100 } },
      isInteger: true,
      maxLength: 6,
      authorization: ["internal", "admin"],
    },
};


export const cleaningEffectivenessConfig = {
    cleaningEffectivenessCalculation: {
       min_time: {
        key: "minStabilizationDaysAfterCIP",
        minValue: 0.01,
        maxValue: 1,
        ranges: { hard: { min: 0.01, max: 1 } },
        leftLabelKey: "minStabilizationLeft",
        rightLabelKey: "minStabilizationRight",
      },
      max_time: {
        key: "maxStabilizationDaysAfterCIP",
        minValue: 1,
        maxValue: 30,
        ranges: { hard: { min: 1, max: 30 } },
        integer: true,
        leftLabelKey: "maxStabilizationLeft",
        rightLabelKey: "maxStabilizationRight",
      },
     
      min_num_points: {
        key: "minPointsForCleaningEffectiveness",
        minValue: 5,
        maxValue: 100,
        ranges: { hard: { min: 5, max: 100 } },
        integer: true,
        leftLabelKey: "minNumPointsLeft",
        rightLabelKey: "minNumPointsRight",
      },
      stabilization_days: {
        key: "deafultStabilizationDaysAfterCIP",
        integer: true,
        isDynamic: true,
        fallbackRanges: { hard: { min: 0.01, max: 30 } },
        leftLabelKey: "stabilizationDaysLeft",
        rightLabelKey: "stabilizationDaysRight",
      },
    },
}

export const CIPPredictionRecommendationConfig = {
  cipPredictionAndRecommendation: {
    top_exp: {
      key: "foulingAggressivenessFactor",
      minValue: 1,
      maxValue: 20,
      ranges: { hard: { min: 1, max: 20 } },
      leftLabelKey: "foulingAggressivenessLeft",
      rightLabelKey: "foulingAggressivenessRight",
    },
    max_evals: {
      key: "numberOfIterationsToFindOptima",
      minValue: 5,
      maxValue: 100,
      ranges: { hard: { min: 5, max: 100 } },
      integer: true,
      leftLabelKey: "numberOfIterationsLeft",
      rightLabelKey: "numberOfIterationsRight",
    },
    adapt_pf_trend: {
      key: "adaptPermeateFlowDropThreshold",
      isBoolean: true,
      threshold: {
        settingsKey: "pf_threshold",
        labelKey: "permeateFlowDropThresholdForCIP",
        minValue: 10,
        maxValue: 100,
        ranges: { hard: { min: 10, max: 100 } },
        leftLabelKey: "permeateFlowThresholdLeft",
        rightLabelKey: "permeateFlowThresholdRight",
      },
    },
    adapt_pressure_drop_trend: {
      key: "adaptPressureDropThreshold",
      isBoolean: true,
      subLabelKey: "pressureDropThresholdForCIP",
      checkboxThresholds: [
        {
          checkboxKey: "pressure_drop_threshold_predictCheckbox1",
          settingsKey: "pressure_drop_threshold_predict",
          cipOptionKey: "percentage",
          defaultChecked: true,
          leftLabelKey: "pressureDropThresholdLeft",
          rightLabelKey: "pressureDropThresholdRight",
        },
        {
          checkboxKey: "pressure_drop_threshold_predictCheckbox2",
          settingsKey: "pressure_drop_abs_threshold_predict",
          cipOptionKey: "absolute",
          defaultChecked: false,
          leftLabelKey: "pressureDropAbsThresholdLeft",
          rightLabelKey: "pressureDropAbsThresholdRight",
        },
      ],
    },
    adapt_salt_passage_trend: {
      key: "adaptSaltPassageThreshold",
      isBoolean: true,
      threshold: {
        settingsKey: "salt_passage_threshold",
        labelKey: "saltPassageIncreaseThresholdForCIP",
        minValue: 10,
        maxValue: 100,
        ranges: { hard: { min: 10, max: 100 } },
        leftLabelKey: "saltPassageThresholdLeft",
        rightLabelKey: "saltPassageThresholdRight",
      },
    },
    simulation_improve_accuracy: {
      key: "simulationImproveAccuracy",
      isBoolean: true,
    },
    optimization_target: {
      key: "optimizationObjective",
      type: "select",
    },
  },
};

export const lifetimePredictionConfig = {
  failure_probability_threshold: {
    key: "failureProbabilityThreshold",
    minValue: 50,
    maxValue: 100,
    ranges: { hard: { min: 50, max: 100 } },
  },
};